import { useEffect, useRef } from 'react';

/**
 * The "Escape closes it" wiring shared by `useMenu` (a dropdown) and
 * `ShortcutCheatsheet` (a modal) — extracted so the two don't carry their
 * own copies of the same listener. `onEscape` is read via a ref, not a
 * `useEffect` dependency, so the listener is only added/removed when
 * `active` changes — not on every render a new inline callback is passed.
 */
export function useEscapeKey(onEscape: () => void, active: boolean): void {
  const onEscapeRef = useRef(onEscape);
  onEscapeRef.current = onEscape;

  useEffect(() => {
    if (!active) return;
    function onKeyDown(e: KeyboardEvent) {
      if (e.key === 'Escape') onEscapeRef.current();
    }
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [active]);
}
